var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"audit-list-expand"},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.$t('audit.comments'))+":")])]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.comments)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }